import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { GsmAbortDialogComponent } from '@app/shared/components/dialog/gsm-abort-dialog/gsm-abort-dialog.component';
import { ReactiveDialogService } from '@app/shared/services/ui/reactive-dialog.service';
import { SchadenMeldenComponent } from '@app/views/vertriebscockpit/gsm/schaden-melden/schaden-melden.component';
import { map, take } from 'rxjs/operators';

// This guard is in place to show a dialog to prompt the users acceptance before leaving a route.

@Injectable({
  providedIn: 'root'
})
export class GsmAbortGuard implements CanDeactivate<SchadenMeldenComponent> {
  private dialogService = inject(ReactiveDialogService);


  canDeactivate(component: SchadenMeldenComponent) {
    if ((component.processInstanceId && !component.showBackButton) || component.hasKonnex) {
      const dialogConf = {
        maxWidth: '1000px',
        data:     {
          title:        'Schadenmeldung verlassen',
          text_pre:     'Sie können den aktuellen Bearbeitungsstand als Entwurf speichern, um die Bearbeitung zu einem späteren Zeitpunkt fortzuführen.',
          text_post:    'Möchten Sie den Entwurf speichern?',
          buttonConfig: {
            visible:       true,
            actionButtons: [
              {
                name:  'Verlassen, nicht speichern',
                color: 'accent'
              },
              {
                name:  'Abbrechen',
                color: 'accent'
              }
            ]
          }
        }
      };
      if (component.hasKonnex) {
        dialogConf.data.text_pre = 'Sie können den aktuellen Bearbeitungsstand als Entwurf speichern, um die Konnexmeldung zu einem späteren Zeitpunkt fortzuführen.';
        dialogConf.data.text_post = 'Möchten Sie die Konnexmeldung als Entwurf speichern?';
        dialogConf.data.buttonConfig.actionButtons[0].name = 'Zurück zur Übersicht, Konnexmeldung verwerfen';
      }

      const dialogRef = this.dialogService.open(GsmAbortDialogComponent, dialogConf);
      return dialogRef.afterClosed()
        .pipe(take(1), map(result => {
          if (result && result.status === 'success') {
            // FIXME possible bug: was this meant to return the result of deleteProcess()?
            component.deleteProcess(component.processInstanceId)
              .subscribe();
            return true;
          } else {
            return result && result.context === 'save';
          }
        }));
    }
    return true;
  }
}
